const CONFIG = {
  API_BASE_URL: "https://durumrapor.com/KasapPosAPI",
  PUSH_TOKEN_REGISTER_PATH: '/push/register',
  PUSH_TOKEN_UNREGISTER_PATH: '/push/unregister',
  PUSH_PREFERENCES_PATH: '/push/preferences',
  SOCKET_URL: "https://kasap-socket.durumrapor.com",
  ENV: "false"
};

export default CONFIG;